import { z } from 'zod';
import { uuidSchema } from './common.js';
/**
 * Stock (ADR-09).
 *
 * ⭐ Un mouvement ne se corrige jamais : il s'annule par un mouvement inverse.
 * C'est ce qui rend l'inventaire défendable devant un contrôle — l'historique
 * montre l'erreur ET sa correction, au lieu de présenter un solde qu'on ne
 * peut plus expliquer.
 */
export const stockMovementKindSchema = z.enum(['in', 'out', 'adjustment']);
export const STOCK_KIND_LABELS = {
    in: 'Entrée',
    out: 'Sortie',
    adjustment: 'Ajustement',
};
export const stockMovementInputSchema = z
    .object({
    id: uuidSchema.optional(),
    itemId: uuidSchema,
    kind: stockMovementKindSchema,
    /** Toujours SAISIE EN POSITIF : le sens vient de `kind`, pas de l'utilisateur. */
    quantity: z.coerce.number().refine((q) => q !== 0, 'La quantité ne peut pas être nulle'),
    reason: z.string().trim().max(200).optional(),
    reference: z.string().trim().max(80).optional(),
})
    .transform((v) => ({
    ...v,
    // Une sortie est stockée en négatif. Demander à l'utilisateur de taper
    // « -3 » serait une source d'erreurs au comptoir ; un ajustement, lui,
    // garde le signe saisi car il peut aller dans les deux sens.
    quantity: v.kind === 'out' ? -Math.abs(v.quantity) : v.kind === 'in' ? Math.abs(v.quantity) : v.quantity,
}));
//# sourceMappingURL=stock.js.map